import * as React from "react";

import Select from "react-select";

import { Defaults } from "@common/_constants";
import { GlobalConfig } from "@common/utils/config";
import { Facet } from "common/models/Facet";

/*===========================================================================
  Facets
/*======================================================================== */
interface FacetsProps {
    facets: Facet[];
    onFacetChange: (facet: Facet) => void;
    onDistanceChange?: (value: any) => void;
    searchRadiusInMiles?: number;
    locationSearchTerm?: string;
    overlay?: boolean;
}

export const Facets = (props: FacetsProps) => {
    const classes = ["c-facets"];
    if (props.overlay) classes.push("c-facets--overlay");
    return (
        <div className={classes.join(" ")}>
            {props.locationSearchTerm && props.searchRadiusInMiles && (
                <DistanceSelect
                    searchRadiusInMiles={props.searchRadiusInMiles}
                    onDistanceChange={props.onDistanceChange}
                />
            )}
            {props.facets.map((group, groupIndex) => (
                <FacetGroup
                    title={group.title}
                    options={group.options}
                    key={group.key}
                >
                    {group.options.map((option, optionIndex) => (
                        <FacetOption
                            key={option.value}
                            facets={props.facets}
                            groupIndex={groupIndex}
                            optionIndex={optionIndex}
                            option={option}
                            onFacetChange={props.onFacetChange}
                        />
                    ))}
                </FacetGroup>
            ))}
        </div>
    );
};

/*===========================================================================
  Facets > FacetGroup
/*======================================================================== */

interface FacetGroupProps {
    options?: any[];
    title: string;
}

interface FacetGroupState {
    isCollapsed: boolean;
}

class FacetGroup extends React.Component<FacetGroupProps, FacetGroupState> {
    state = {
        isCollapsed: true,
    };

    render() {
        const classes = ["c-facets__group"];
        if (this.state.isCollapsed) classes.push("is-collapsed");
        return (
            <div className={classes.join(" ")}>
                <div className="c-facets__group-title">{this.props.title}</div>
                <div className="c-facets__options">{this.props.children}</div>
                {this.props.options &&
                    this.props.options.length >
                        GlobalConfig.ui.facetsHideAfterIndex && (
                        <span
                            className="c-facets__expand c-link c-link--magenta"
                            onClick={() =>
                                this.setState({
                                    isCollapsed: !this.state.isCollapsed,
                                })
                            }
                        >
                            {this.state.isCollapsed ? "more" : "less"}
                        </span>
                    )}
            </div>
        );
    }
}

/*===========================================================================
  Facets > FacetGroup > FacetOption
/*======================================================================== */
interface FacetOptionProps {
    facets: any[];
    groupIndex: number;
    optionIndex: number;
    option: any;
    onFacetChange: (facet: any) => void;
}

const FacetOption = (props: FacetOptionProps) => {
    const classes = ["c-facets__option"];
    const data = props.facets;
    const facet = props.option;
    if (props.optionIndex > GlobalConfig.ui.facetsHideAfterIndex) {
        classes.push("is-overflow");
    }

    const toggleSelected = () => {
        // tslint:disable-next-line:no-string-literal
        data[props.groupIndex]["options"][props.optionIndex][
            // tslint:disable-next-line:no-string-literal
            "selected"
        ] = !facet.selected;
        const b = data[props.groupIndex];
        // tslint:disable-next-line:no-string-literal
        b.options = [data[props.groupIndex]["options"][props.optionIndex]];
        props.onFacetChange(b);
    };

    return (
        <div className={classes.join(" ")} onClick={toggleSelected}>
            <span className="c-facets__label">{facet.label}</span>
            <span className="c-facets__count">
                {facet.count}
                {facet.selected ? "X" : ""}
            </span>
        </div>
    );
};

/*===========================================================================
  Facets > FacetGroup > DistanceSelect
/*======================================================================== */
interface DistanceSelectProps {
    searchRadiusInMiles: number;
    onDistanceChange?: (value: any) => void;
}

const DistanceSelect = (props: DistanceSelectProps) => {
    const classesGroup = ["c-facets__group"];
    const classesOption = ["c-facets__option", "selectInput"];

    const handleChange = selectedOption => {
        const value = selectedOption.value;
        if (props.onDistanceChange) props.onDistanceChange(value);
    };

    return (
        <div className={classesGroup.join(" ")}>
            <div className="c-facets__group-title">distance</div>
            <div className="c-select" data-cy="distance-options">
                <Select
                    name="distance"
                    value={props.searchRadiusInMiles}
                    className={classesOption.join(" ")}
                    onChange={handleChange}
                    options={Defaults.DistanceOptions}
                    clearable={false}
                />
            </div>
        </div>
    );
};

export default Facets;
